// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__1XXnA","modalContent":"Modal_modalContent__Enmak","vectorKiri":"Modal_vectorKiri__iUIEL","vectorKanan":"Modal_vectorKanan__-gtvH"};